var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "sideMenu-callIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st00{fill:#47A142;}\r\n\t.st01{fill:#268534;}\r\n\t.st02{fill:#58AD51;}\r\n\t.st03{fill:#ED1600;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st00",
    d: "M362.8,330c13.8-12,34.7-10.6,46.8,3.1l58.2,66.5c12,13.8,10.6,34.7-3.1,46.8l-40.2,35.2 c-21.8,16.6-41.4,14.3-41.8,14.3c-8.3-1.5-24.9,1.5-37-2.4c-47.3-15-115.4-45.2-192.9-133.9C75.2,270.9,49.9,194.3,37.7,141.3 c-3.8-16.5,0.4-35.6-0.7-45.6c0-0.3-0.7-19.8,16.2-34.5c1.2-1.1,2.2-2,2.9-2.9l27.9-24.9l11.5-9.2c13.8-12,34.7-10.6,46.8,3.1 l58.2,66.5c12,13.8,10.7,34.7-3.1,46.8l-50.1,43.8c19.2,38,39.9,73.2,75.5,113.9c31.1,35.5,57.2,56.7,87.1,78L362.8,330z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st01",
    d: "M430.7,476.1l-6.3,5.5c-21.8,16.6-41.4,14.3-41.8,14.3c-8.3-1.5-24.9,1.5-37-2.4 c-47.3-15-115.4-45.2-192.9-133.9c-77.5-88.7-102.8-165.3-115-218.3c-3.8-16.5,0.4-35.6-0.7-45.6c0-0.1-0.1-3.9,1.1-9.3 C60.5,306.1,260.2,428.6,430.7,476.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st02",
    d: "M130.5,33.6l34.6,39.5c-15.7-15.9-55.8-45.3-106.3-1.1l45.8-40.1C112.2,25.3,123.8,26.1,130.5,33.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st02",
    d: "M397.2,342.5l34.6,39.5c-15.7-15.9-55.8-45.3-106.3-1.1l45.8-40.1C378.9,334.2,390.6,334.9,397.2,342.5z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st03",
    d: "M331.2,43.9c-19.7,2.5-39.2,5-43.1,5.4c-8.3,1-10.6,2.5-10.6,6.6c0,2,1.2,3.6,8.8,11.3l8.8,8.9L265,106.5 c-29.6,29.7-30.2,30.4-30.2,33.1c0,2.8,0.6,3.5,20.2,23c18.6,18.7,20.3,20.2,22.6,20.2c2.4,0,4.5-2,33-30.5l30.5-30.5l8.7,8.6 c4.8,4.8,9.5,8.9,10.5,9.1c2.5,0.6,5.7-0.7,6.5-2.7c0.8-1.9,11.6-87.4,11.6-91.9c0-4.4-1.8-5.9-7-5.8 C369,39.3,350.9,41.4,331.2,43.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st01",
    d: "M370.9,266.6c19.7-2.5,39.2-5,43.1-5.4c8.3-1,10.6-2.5,10.6-6.6c0-2-1.2-3.6-8.8-11.3l-8.8-8.9l30.2-30.3 c29.6-29.7,30.2-30.4,30.2-33.1s-0.6-3.5-20.2-23c-18.6-18.7-20.3-20.2-22.6-20.2c-2.4,0-4.5,2-33,30.5l-30.5,30.5l-8.7-8.6 c-4.8-4.8-9.5-8.9-10.5-9.1c-2.5-0.6-5.7,0.7-6.5,2.7c-0.8,1.9-11.6,87.4-11.6,91.9c0,4.4,1.8,5.9,7,5.8 C333.1,271.1,351.2,269,370.9,266.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.9c714e632ad231d2a8de19643bbaeef5.svg";
export { ForwardRef as ReactComponent };